// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-38412aae] .card-header {\n  padding: 0.5rem 1rem;\n  background-color: #f1f0f0;\n}", ""]);
// Exports
module.exports = exports;
